'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./style.global.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var svgHoc = function svgHoc(iconImport) {
    var HOC = function (_Component) {
        _inherits(HOC, _Component);

        function HOC(props) {
            _classCallCheck(this, HOC);

            var _this = _possibleConstructorReturn(this, (HOC.__proto__ || Object.getPrototypeOf(HOC)).call(this, props));

            _this.state = {
                svg: null,
                width: 0,
                height: 0
            };
            _this.container = null;
            return _this;
        }

        _createClass(HOC, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.fetchSvg();
            }
        }, {
            key: 'fetchSvg',
            value: function fetchSvg() {
                var _this2 = this;

                fetch(iconImport).then(function (r) {
                    return r.text();
                }).then(function (text) {
                    var viewBoxStr = text.match(/viewBox="([^"]*)"/)[1];
                    var viewBox = viewBoxStr.split(' ');
                    _this2.setState({ svg: text, width: viewBox[2], height: viewBox[3] });
                });
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                var newHeight = this.container.offsetWidth * (this.state.height / this.state.width);
                var svg = this.container.getElementsByTagName('svg');

                if (svg.length !== 1) return;

                svg = this.container.getElementsByTagName('svg')[0];
                var oldHeight = svg.getAttribute('height');

                if (Math.abs(Number(oldHeight) - newHeight) < 1) return;
                this.setState({
                    svg: this.state.svg.replace(/(<svg[^>]*height=")([^"]*)|<svg/, function () {
                        if (arguments.length <= 2 ? undefined : arguments[2]) {
                            //has height
                            return (arguments.length <= 1 ? undefined : arguments[1]) + newHeight;
                        } else {
                            return '<svg height="' + newHeight + '"';
                        }
                    })
                });
            }
        }, {
            key: 'render',
            value: function render() {
                var _this3 = this;

                var className = this.props.className;


                var classNames = ['mig-svg-icon', className];

                return _react2.default.createElement(
                    'div',
                    { ref: function ref(e) {
                            _this3.container = e;
                        }, className: classNames.join(' ') },
                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.svg } })
                );
            }
        }]);

        return HOC;
    }(_react.Component);

    HOC.propTypes = {
        type: _propTypes2.default.string,
        className: _propTypes2.default.string
    };
    return HOC;
};

exports.default = svgHoc;